import { Typography, Link, SxProps } from '@mui/material';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';

const linkSx: SxProps = { verticalAlign: 'baseline' };

type TalentPoolCreationToastMessageProps = {
  talentPoolTitle: string;
  talentPoolId: string;
};

export const TalentPoolCreationToastMessage: React.FC<
  TalentPoolCreationToastMessageProps
> = ({ talentPoolTitle, talentPoolId }) => {
  const { navigateToPath } = usePathsV2();
  return (
    <Typography variant="body1">
      View{' '}
      <Link
        component="button"
        variant="body1"
        onClick={() =>
          navigateToPath.TALENT_POOL_DETAILS({
            talentPoolId
          })
        }
        sx={linkSx}
      >
        {talentPoolTitle}
      </Link>{' '}
      to see the updated list.
    </Typography>
  );
};
